import React, { FC, useContext } from 'react'
import { Grid } from '@mui/material'
import styles from '../../../styles'
import { makeStyles } from 'tss-react/mui'
import { FormattedMessage } from 'react-intl'
import Link from '../../link/Link'
import { fontFamilyBlackerDisplay, gecinaBlueMain } from '../../../theme'
import { SelectionPaneContext } from './SelectionPaneContext'
import ClientCard from './ClientCard'
import links from '../../../enums/linksEnum'
import { useNavigate } from 'react-router'
import { RechercheContactContext } from '../../../modules/rechercheContact/components/RechercheContactContext'

const BlocClient: FC = () => {
	const { classes } = useStyles()
	const { hasCurrentClient } = useContext(SelectionPaneContext)
	const { resetFiltreContact } = useContext(RechercheContactContext)
	const navigate = useNavigate()

	return (
		<Grid container item spacing="10px">
			<Grid item className={classes.titleStyle}>
				<FormattedMessage
					id="selectionPanel.client.title"
					defaultMessage="Recherche par prospect"
					description="Recherche par prospect"
				/>
			</Grid>
			{
				hasCurrentClient &&
				<Grid container item>
					<ClientCard />
				</Grid>
			}
			<Grid container item justifyContent="flex-end">
				<Link
					href={links.RECHERCHE_CONTACT}
					color="colorAccessibility"
					textStyle="text4"
					onClick={() => {
						resetFiltreContact()
						navigate(links.RECHERCHE_CONTACT)
					}}
					prevent
				>
					<FormattedMessage
						id={`selectionPanel.${hasCurrentClient ? 'change' : 'client.search'}`}
						defaultMessage="Rechercher un contact"
						description="Rechercher un contact"
					/>
				</Link>
			</Grid>
		</Grid>
	)
}

const useStyles = makeStyles()((theme) => ({
	...styles(theme),
	titleStyle: {
		fontFamily: fontFamilyBlackerDisplay,
		fontSize: 18,
		fontWeight: 900,
		color: gecinaBlueMain
	}
}))

export default BlocClient